import { Reducer } from 'redux';

import { TaxState, TaxTypes } from './types';

const INITIAL_STATE: TaxState = {
  taxData: null,
  taxList: [],
  error: false,
  loading: false,
};

const reducer: Reducer<TaxState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST TAX
    case TaxTypes.LIST_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        taxList: INITIAL_STATE.taxList,
      };
    case TaxTypes.LIST_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        taxList: action.payload.taxList,
      };
    case TaxTypes.LIST_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        taxList: INITIAL_STATE.taxList,
      };

    // CASES GET TAX
    case TaxTypes.GET_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        taxData: INITIAL_STATE.taxData,
      };
    case TaxTypes.GET_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        taxData: action.payload.taxData,
      };
    case TaxTypes.GET_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        taxData: INITIAL_STATE.taxData,
      };

    // CASES CREATE TAX
    case TaxTypes.CREATE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        taxData: INITIAL_STATE.taxData,
      };
    case TaxTypes.CREATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        taxData: action.payload.taxData,
      };
    case TaxTypes.CREATE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        taxData: INITIAL_STATE.taxData,
      };

    // CASES UPDATE TAX
    case TaxTypes.UPDATE_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case TaxTypes.UPDATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        taxData: action.payload.taxData,
      };

    case TaxTypes.UPDATE_TAX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE TAX
    case TaxTypes.DELETE_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case TaxTypes.DELETE_TAX_SUCCESS:
      return { ...state, loading: false, error: false };

    case TaxTypes.DELETE_TAX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES ATTACH TAX
    case TaxTypes.ATTACH_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case TaxTypes.ATTACH_TAX_SUCCESS:
      return { ...state, loading: false, error: false };

    case TaxTypes.ATTACH_TAX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DETACH TAX
    case TaxTypes.DETACH_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case TaxTypes.DETACH_TAX_SUCCESS:
      return { ...state, loading: false, error: false };

    case TaxTypes.DETACH_TAX_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
